import React, { useEffect, useState } from "react";

import { Button, message, Modal, Space, Table, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import DownloadIcon from "../../../../assets/icons/receipt_icon.png";
import PageHeader from "../../../PageHeader";
import "./../styles/policy.css";
import { AddCards } from "./AddCard";
import {
  CardLimitSet,
  card_policy_delete,
  get_card_policies,
  ShowCardPolicy,
  show_card_policy,
  CardPoliciesDelete,
} from "../../../../actions/cards/cards";
import { hasAccess } from "../../../../utils";
import { ErrorModal } from "../../../../actions/dashboard/dashboard";

const { Title } = Typography;

const Cards = () => {
  const cardPoliciesRes = useSelector(
    (state) => state?.cards?.get_card_policies,
  );
  const saveCardPolicyRes = useSelector(
    (state) => state?.cards?.cartSetPolicies,
  );

  const [selectedRow, setSelectedRow] = useState({});

  const show_policy = useSelector(
    (state) => state?.cards?.show_card_policy?.data?.response || {},
  );
  const delete_policy = useSelector(
    (state) => state?.cards?.delete_card_policy || {},
  );
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedRow({});
    dispatch({
      type: ShowCardPolicy.RESET,
    });
  };

  useEffect(() => {
    dispatch(get_card_policies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (saveCardPolicyRes?.data?.status) {
      message.success(
        <span className="messageText">{`Bulk Card policy limit ${selectedRow?.id ? "updated" : "created"} successfully.`}</span>,
      );
      dispatch(get_card_policies());
      handleCancel();
      dispatch({
        type: CardLimitSet.RESET,
      });
    }
    if (saveCardPolicyRes?.data?.status === false) {
      dispatch({
        type: ErrorModal.SUCCESS,
        payload: {
          open: true,
          errMsg:
            typeof saveCardPolicyRes?.data?.errors === "string"
              ? saveCardPolicyRes?.data?.errors
              : saveCardPolicyRes?.data?.errors?.message,
        },
      });
      dispatch({
        type: CardLimitSet.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveCardPolicyRes]);

  useEffect(() => {
    if (delete_policy?.data?.status) {
      dispatch(get_card_policies());
      handleCancel();
      dispatch({
        type: CardPoliciesDelete.RESET,
      });
    }
    if (delete_policy?.data?.status === false) {
      dispatch({
        type: CardPoliciesDelete.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delete_policy]);

  const showEditModal = (id) => {
    setIsModalVisible(true);
    dispatch(
      show_card_policy({
        card_policy_id: id,
      }),
    );
  };

  const columns = [
    // {
    //   title: "Type",
    //   dataIndex: "role_name",
    //   key: "role_name",
    //   render: (text) => <div className="typeDiv">{text}</div>,
    // },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, data) => {
        return (
          <div className={`render_common_style status_${data?.Status}`}>
            {text}
          </div>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => status,
    },
    hasAccess("policies_and_limits", "write")
      ? {
          title: "Actions",
          key: "action",
          render: (text, record) => (
            <Space key={record.id} size="middle">
              <button
                onClick={() => {
                  setSelectedRow(record);
                  showEditModal(record.id);
                }}
              >
                <img src={EditIcon} alt={"logo"} className="action-logo" />
              </button>
              {record.key !== "1" ? (
                <button onClick={() => dispatch(card_policy_delete(record.id))}>
                  <img src={DeleteIcon} alt={"logo"} className="action-logo" />
                </button>
              ) : null}
              {record.file_status_url ? (
                <button
                  onClick={() => {
                    window.open(record.file_status_url, "_blank");
                  }}
                >
                  <img
                    src={DownloadIcon}
                    alt={"logo"}
                    className="action-logo"
                  />
                </button>
              ) : null}
            </Space>
          ),
        }
      : {},
  ];

  return (
    <>
      {isModalVisible && (
        <Modal
          title={
            <Title level={4}>
              {selectedRow?.id ? "Edit" : "Add"} Card Policy &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          }
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[]}
          className="right-alinged-modal lg"
          width={650}
        >
          <AddCards
            handleCancel={handleCancel}
            selectedRow={{ ...selectedRow, ...show_policy }}
          />
        </Modal>
      )}
      <div className="heading-div">
        <PageHeader
          title={`Policies & Limits`}
          navigation={{
            Home: "/dashboard/",

            "Policies & Limits": null,
          }}
        />
      </div>
      {hasAccess("policies_and_limits", "write") && (
        <Button onClick={() => setIsModalVisible(true)} className="mb1 addNew">
          <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
          Add New Policy
        </Button>
      )}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={cardPoliciesRes?.data?.response?.cards}
        className="settingsTable"
      />
    </>
  );
};

export default Cards;
